import { NavBar } from '../../../../themes/components/Navbar';
import { Sidebar } from '../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { Typography } from '@material-ui/core';
import { getFromSessionStorage } from '../../../../contexts/LocalStorage';

export const Perfil = () => {

    function fieldForm(label: string, value: string | null, id: string) {

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input disabled={true} type="text" className={"form-control"} id={id} name={id} value={value ? value : ""}/>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div>
                    <NavBar />
                    <div className="main-content-usuario-perfil">
                        <div className="formulario-novo-cliente-area">
                            <Typography className="titulo-novo-cliente">Informações do Usuário</Typography>
                            <form className="formulario-novo-cliente">
                                <div className="form-row-user-profile">                                    
                                    {fieldForm("Código", getFromSessionStorage("user_codrep"), "codrep")}
                                    {fieldForm("Nome", getFromSessionStorage("nomRep"), "nome")}
                                    {fieldForm("E-mail", getFromSessionStorage("intNet"), "email")}
                                    {fieldForm("Login", getFromSessionStorage("userlogin"), "login")}
                                </div>
                            </form>
                            <Typography className="titulo-novo-cliente">Informações do Sistema</Typography>
                            <form className="formulario-novo-cliente">
                                <div className="form-row-user-profile">
                                    {fieldForm("Tabela Padrão", getFromSessionStorage("user_codtab"), "tabPreco")}
                                    {fieldForm("Pedido Container em Dólar", getFromSessionStorage("pedDol"), "pedDol")}
                                    {fieldForm("Cotação U$", parseFloat(getFromSessionStorage("cotDol") as string).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }), "cotDol")}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster />
        </div>
    )
}